<template>
  <div>
    <AbstractChat v-if="tutorialChat && chatStart" X1="Hamochie" :chats="tutorialChat" :callback="callback" />
    <SkipTut />
    <ApiErrorDialog v-if="apiError && apiError.isError" :api="apiError" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    AbstractChat: () =>
      import(
        /* webpackChunkName: "component-abstract-chat" */ "@/components/tutorial/AbstractChat"
      ),
    SkipTut: () =>
      import(
        /* webpackChunkName: "component-skip-tut" */ "@/components/tutorial/SkipTut"
      ),
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
  },
  computed: mapState({
    tutorial: (state) => state.tutorial.data,
    settings: (state) => state.settings.data,
  }),
  props: ["intraction", "context", "condition"],
  data: () => ({
    tutorialApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    chatStart: false,
    tutorialChat: null,
    tutWroldIntroChats: [],
    tutExploreEventsChats: [],
    tutExploreEventsChats2: [],
    tutExploreShopChats: [],
    tutExploreTowerChats: [],
    tutExploreTowerChats2: [],
    tutExploreAbcChats: [],
    tutExploreAbcChats2: [],
    tutExploreAbcChats3: [],
    tutExploreFamilyChats: [],
    isEnoughCoin: false,
    isOngoingEvent: false,
    apiError: null,
    eventsApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    coinApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
  }),
  async created() {
    this.tutWroldIntroChats = [
      {
        citizen: "Hamochi",
        chat: this.$t("newTutorial.worldIntro.dialog_1"),
        sound: "sfx_chat_1",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("newTutorial.worldIntro.dialog_2"),
        sound: "sfx_chat_3",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("newTutorial.worldIntro.dialog_3"),
        sound: "sfx_chat_2",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("newTutorial.worldIntro.dialog_4"),
        sound: "sfx_chat_3",
      },
    ];

    this.tutExploreEventsChats = [
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreEvents.dialog_1"),
        sound: "sfx_chat_2",
      },
    ];

    this.tutExploreEventsChats2 = [
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreEvents.dialog_5"),
        sound: "sfx_chat_2",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreEvents.dialog_6"),
        sound: "sfx_chat_2",
      },
    ];

    this.tutExploreShopChats = [
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreShop.dialog_1"),
        sound: "sfx_chat_2",
      },
    ];

    this.tutExploreTowerChats = [
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreTower.dialog_1"),
        sound: "sfx_chat_1",
      },
    ];

    this.tutExploreTowerChats2 = [
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreTower.dialog_4"),
        sound: "sfx_chat_2",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreTower.dialog_5"),
        sound: "sfx_chat_3",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreTower.dialog_6"),
        sound: "sfx_chat_2",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreTower.dialog_7"),
        sound: "sfx_chat_1",
      },
    ];

    this.tutExploreAbcChats = [
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreABC.dialog_1"),
        sound: "sfx_chat_1",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreABC.dialog_2"),
        sound: "sfx_chat_3",
      },
    ];

    this.tutExploreAbcChats2 =
      this.condition && this.condition == "CLAIMED"
        ? [
          {
            citizen: "Hamochi",
            chat: this.$t("tutorial.exploreABC.dialog_6"),
            sound: "sfx_chat_1",
          },
          {
            citizen: "Hamochi",
            chat: this.$t("tutorial.exploreABC.dialog_7"),
            sound: "sfx_chat_2",
          },
          {
            citizen: "Hamochi",
            chat: this.$t("tutorial.exploreABC.dialog_9"),
            sound: "sfx_chat_3",
          },
          {
            citizen: "Hamochi",
            chat: this.$t("tutorial.exploreABC.dialog_10"),
            sound: "sfx_chat_2",
          },
        ]
        : [
          {
            citizen: "Hamochi",
            chat: this.$t("tutorial.exploreABC.dialog_6"),
            sound: "sfx_chat_1",
          },
          {
            citizen: "Hamochi",
            chat: this.$t("tutorial.exploreABC.dialog_7"),
            sound: "sfx_chat_3",
          },
          {
            citizen: "Hamochi",
            chat: this.$t("tutorial.exploreABC.dialog_8"),
            sound: "sfx_chat_2",
          },
        ];

    this.tutExploreAbcChats3 = [
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreABC.dialog_12"),
        sound: "sfx_chat_1",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreABC.dialog_13"),
        sound: "sfx_chat_3",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreABC.dialog_14"),
        sound: "sfx_chat_2",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreABC.dialog_15"),
        sound: "sfx_chat_3",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreABC.dialog_16"),
        sound: "sfx_chat_2",
      },
    ];

    this.tutExploreFamilyChats = [
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreFamily.dialog_1"),
        sound: "sfx_chat_1",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreFamily.dialog_2"),
        sound: "sfx_chat_3",
      },
    ];

    this.tutExploreFamilyChats2 = this.condition && this.condition == "CONNECTED" ? [
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreFamily.dialog_4_1"),
        sound: "sfx_chat_1",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreFamily.dialog_5"),
        sound: "sfx_chat_3",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreFamily.dialog_6"),
        sound: "sfx_chat_2",
      },
    ] : [
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreFamily.dialog_4_2"),
        sound: "sfx_chat_1",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreFamily.dialog_5"),
        sound: "sfx_chat_3",
      },
      {
        citizen: "Hamochi",
        chat: this.$t("tutorial.exploreFamily.dialog_6"),
        sound: "sfx_chat_2",
      },
    ];

    if (this.context == "WORLD") {
      if (!this.tutorial.Ongoing) await this.loadTutorials();

      if (this.tutorial.Ongoing == "tutWroldIntro" && this.tutorial.Step == 4) {
        await this.completeTutorial("tutWroldIntro");
        this.checkAndStartEventsTut();
      }

      // Check Tutorials
      this.checkAndStartWroldIntroTut();

      const arrowEl = document.querySelector("#arrowLeft");
      if (arrowEl) {
        arrowEl.addEventListener("click", () => {
          if (
            this.tutorial.Ongoing == "tutWroldIntro" &&
            this.tutorial.Step == 2
          ) {
            let tempTut = this.$_.cloneDeep(this.tutorial);
            tempTut.Ongoing = "tutWroldIntro";
            tempTut.Step = 3;
            this.$store.commit("updateTutorial", tempTut);
            this.startIntroJS(
              "#arrowRight",
              this.$t("newTutorial.worldIntro.dialog_6"),
              2000
            );
          } else if (
            this.tutorial.Ongoing == "tutExploreEvents" &&
            this.tutorial.Step == 2
          ) {
            let tempTut = this.$_.cloneDeep(this.tutorial);
            tempTut.Ongoing = "tutExploreEvents";
            tempTut.Step = 3;
            this.$store.commit("updateTutorial", tempTut);

            this.$emit("update:intraction", "pointer-events: none;");
            setTimeout(() => {
              this.tutorialChat = this.tutExploreEventsChats2;
              this.chatStart = true;
              this.$emit("update:intraction", "pointer-events: all;");
            }, 800);
          }
        });
      }

      const arrowEr = document.querySelector("#arrowRight");
      if (arrowEr) {
        arrowEr.addEventListener("click", () => {
          if (
            this.tutorial.Ongoing == "tutWroldIntro" &&
            this.tutorial.Step == 3
          ) {
            let tempTut = this.$_.cloneDeep(this.tutorial);
            tempTut.Ongoing = "tutWroldIntro";
            tempTut.Step = 4;
            this.$store.commit("updateTutorial", tempTut);
            this.startIntroJS(
              "#buttonHome",
              this.$t("newTutorial.worldIntro.dialog_7"),
              2000
            );
          } else if (
            this.tutorial.Ongoing == "tutExploreTower" &&
            this.tutorial.Step == 1.5
          ) {
            let tempTut = this.$_.cloneDeep(this.tutorial);
            tempTut.Ongoing = "tutExploreTower";
            tempTut.Step = 2;
            this.$store.commit("updateTutorial", tempTut);

            this.startIntroJS(
              "#arrowRight",
              this.$t("tutorial.exploreTower.dialog_2")
            );
          } else if (
            this.tutorial.Ongoing == "tutExploreTower" &&
            this.tutorial.Step == 2
          ) {
            let tempTut = this.$_.cloneDeep(this.tutorial);
            tempTut.Ongoing = "tutExploreTower";
            tempTut.Step = 3;
            this.$store.commit("updateTutorial", tempTut);
            this.startIntroJS(
              "#entrance",
              this.$t("tutorial.exploreTower.dialog_3"),
              2000
            );
          } else if (
            this.tutorial.Ongoing == "tutExploreAbc" &&
            this.tutorial.Step == 1.5
          ) {
            let tempTut = this.$_.cloneDeep(this.tutorial);
            tempTut.Ongoing = "tutExploreAbc";
            tempTut.Step = 2;
            this.$store.commit("updateTutorial", tempTut);

            this.startIntroJS(
              "#arrowRight",
              this.$t("tutorial.exploreABC.dialog_4")
            );
          } else if (
            this.tutorial.Ongoing == "tutExploreAbc" &&
            this.tutorial.Step == 2
          ) {
            let tempTut = this.$_.cloneDeep(this.tutorial);
            tempTut.Ongoing = "tutExploreAbc";
            tempTut.Step = 3;
            this.$store.commit("updateTutorial", tempTut);

            this.startIntroJS(
              "#arrowRight",
              this.$t("tutorial.exploreABC.dialog_4")
            );
          } else if (
            this.tutorial.Ongoing == "tutExploreAbc" &&
            this.tutorial.Step == 3
          ) {
            let tempTut = this.$_.cloneDeep(this.tutorial);
            tempTut.Ongoing = "tutExploreAbc";
            tempTut.Step = 4;
            this.$store.commit("updateTutorial", tempTut);

            this.startIntroJS(
              "#entrance",
              this.$t("tutorial.exploreABC.dialog_5")
            );
          }
        });
      }
    } else if (this.context == "MATH") {
      if (
        this.tutorial.Ongoing == "tutExploreTower" &&
        this.tutorial.Step == 3
      ) {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreTower";
        tempTut.Step = 4;
        this.$store.commit("updateTutorial", tempTut);
        this.$emit("update:intraction", "pointer-events: none;");
        setTimeout(() => {
          this.tutorialChat = this.tutExploreTowerChats2;
          this.chatStart = true;
          this.$emit("update:intraction", "pointer-events: all;");
        }, 800);
      }
    } else if (this.context == "ABC_BOOKS") {
      if (this.tutorial.Ongoing == "tutExploreAbc") {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreAbc";
        tempTut.Step = 5;
        this.$store.commit("updateTutorial", tempTut);
        this.$emit("update:intraction", "pointer-events: none;");
        setTimeout(() => {
          this.tutorialChat = this.tutExploreAbcChats2;
          this.chatStart = true;
          this.$emit("update:intraction", "pointer-events: all;");
        }, 800);
      }
    } else if (this.context == "ABC_CHAPTERS") {
      if (this.tutorial.Ongoing == "tutExploreAbc") {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreAbc";
        tempTut.Step = 6;
        this.$store.commit("updateTutorial", tempTut);
        this.$emit("update:intraction", "pointer-events: none;");
        setTimeout(() => {
          this.tutorialChat = this.tutExploreAbcChats3;
          this.chatStart = true;
          this.$emit("update:intraction", "pointer-events: all;");
        }, 800);
      }
    } else if (this.context == "FAMILY") {
      if (this.tutorial.Ongoing == "tutExploreFamily") {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreFamily";
        tempTut.Step = 2;
        this.$store.commit("updateTutorial", tempTut);
        this.$emit("update:intraction", "pointer-events: none;");
        setTimeout(() => {
          this.tutorialChat = this.tutExploreFamilyChats2;
          this.chatStart = true;
          this.$emit("update:intraction", "pointer-events: all;");
        }, 800);
      }
    }
  },
  mounted() {
    //
  },
  methods: {
    checkAndStartWroldIntroTut() {
      const tutWroldIntro = this.tutorial.Tutorial.filter(function (entry) {
        return entry.key == "tutWroldIntro";
      });
      if (tutWroldIntro.length == 0) {
        if (this.$router.currentRoute.name != "PageWorldNews")
          this.$router.push({
            name: "PageWorldNews",
          });
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutWroldIntro";
        tempTut.Step = 1;
        this.$store.commit("updateTutorial", tempTut);
        this.$emit("update:intraction", "pointer-events: none;");
        setTimeout(() => {
          this.tutorialChat = this.tutWroldIntroChats;
          this.chatStart = true;
          this.$emit("update:intraction", "pointer-events:all;");
        }, 800);
      } else {
        this.checkAndStartEventsTut();
      }
    },
    async checkAndStartEventsTut() {
      const tutExploreEvents = this.tutorial.Tutorial.filter(function (entry) {
        return entry.key == "tutExploreEvents";
      });
      await this.loadEvents();
      if (tutExploreEvents.length == 0 && this.isOngoingEvent) {
        if (this.$router.currentRoute.name != "PageWorldNews")
          this.$router.push({
            name: "PageWorldNews",
          });
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreEvents";
        tempTut.Step = 1;
        this.$store.commit("updateTutorial", tempTut);
        this.$emit("update:intraction", "pointer-events: none;");
        setTimeout(() => {
          this.tutorialChat = this.tutExploreEventsChats;
          this.chatStart = true;
          this.$emit("update:intraction", "pointer-events: all;");
        }, 800);
      } else {
        this.checkAndStartShopTut();
      }
    },
    async checkAndStartShopTut() {
      const tutExploreShop = this.tutorial.Tutorial.filter(function (entry) {
        return entry.key == "tutExploreShop";
      });
      await this.loadCoins();
      if (tutExploreShop.length == 0 && this.isEnoughCoin) {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreShop";
        tempTut.Step = 1;
        this.$store.commit("updateTutorial", tempTut);
        this.$emit("update:intraction", "pointer-events: none;");
        setTimeout(() => {
          this.tutorialChat = this.tutExploreShopChats;
          this.chatStart = true;
          this.$emit("update:intraction", "pointer-events: all;");
        }, 800);
      } else {
        this.checkAndStartTowerTut();
      }
    },
    checkAndStartTowerTut() {
      const tutExploreTower = this.tutorial.Tutorial.filter(function (entry) {
        return entry.key == "tutExploreTower";
      });
      if (tutExploreTower.length == 0) {
        if (this.$router.currentRoute.name != "PageWorldNews")
          this.$router.push({
            name: "PageWorldNews",
          });
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreTower";
        tempTut.Step = 1;
        this.$store.commit("updateTutorial", tempTut);
        this.$emit("update:intraction", "pointer-events: none;");
        setTimeout(() => {
          this.tutorialChat = this.tutExploreTowerChats;
          this.chatStart = true;
          this.$emit("update:intraction", "pointer-events: all;");
        }, 800);
      } else {
        this.checkAndStartAbcTut();
      }
    },
    checkAndStartAbcTut() {
      const tutExploreAbc = this.tutorial.Tutorial.filter(function (entry) {
        return entry.key == "tutExploreAbc";
      });
      if (tutExploreAbc.length == 0) {
        if (this.$router.currentRoute.name != "PageWorldNews")
          this.$router.push({
            name: "PageWorldNews",
          });
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreAbc";
        tempTut.Step = 1;
        this.$store.commit("updateTutorial", tempTut);
        this.$emit("update:intraction", "pointer-events: none;");
        setTimeout(() => {
          this.tutorialChat = this.tutExploreAbcChats;
          this.chatStart = true;
          this.$emit("update:intraction", "pointer-events: all;");
        }, 800);
      } else {
        this.checkAndStartFamilyTut()
      }
    },
    checkAndStartFamilyTut() {
      const tutExploreFamily = this.tutorial.Tutorial.filter(function (entry) {
        return entry.key == "tutExploreFamily";
      });
      if (tutExploreFamily.length == 0) {
        if (this.$router.currentRoute.name != "PageWorldNews")
          this.$router.push({
            name: "PageWorldNews",
          });
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreFamily";
        tempTut.Step = 1;
        this.$store.commit("updateTutorial", tempTut);
        this.$emit("update:intraction", "pointer-events: none;");
        setTimeout(() => {
          this.tutorialChat = this.tutExploreFamilyChats;
          this.chatStart = true;
          this.$emit("update:intraction", "pointer-events: all;");
        }, 800);
      }
    },
    async loadTutorials() {
      this.tutorialApi.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/tutorial/browse";
      this.tutorialApi.callbackReset = () => {
        this.tutorialApi.isLoading = true;
        this.tutorialApi.isError = false;
        this.tutorialApi.error = null;
      };
      this.tutorialApi.callbackError = (e) => {
        this.tutorialApi.isLoading = false;
        this.tutorialApi.isError = true;
        this.tutorialApi.error = e;
        this.apiError = this.tutorialApi;
      };
      this.tutorialApi.callbackSuccess = (resp) => {
        this.tutorialApi.isLoading = false;
        if (resp.Tutorial) {
          let tempTut = this.$_.cloneDeep(this.tutorial);
          if (this.tutorial) {
            tempTut.Tutorial = resp.Tutorial;
          } else {
            tempTut = resp;
          }
          this.$store.commit("updateTutorial", tempTut);
        } else {
          this.$store.dispatch("resetTutorial");
        }
      };
      await this.$api.fetch(this.tutorialApi);
    },
    async completeTutorial(tutorialKey) {
      this.tutorialApi.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/tutorial/complete";
      this.tutorialApi.callbackReset = () => {
        this.tutorialApi.isLoading = true;
        this.tutorialApi.isError = false;
        this.tutorialApi.error = null;
      };
      this.tutorialApi.callbackError = (e) => {
        this.tutorialApi.isLoading = false;
        this.tutorialApi.isError = true;
        this.tutorialApi.error = e;
        this.apiError = this.tutorialApi;
      };
      this.tutorialApi.callbackSuccess = (resp) => {
        this.tutorialApi.isLoading = false;
        this.$store.commit("updateTutorial", resp);
      };
      this.tutorialApi.params = {
        key: tutorialKey,
      };
      await this.$api.fetch(this.tutorialApi);
    },
    async loadEvents() {
      this.eventsApi.method = "GET";
      this.eventsApi.url =
        this.$api.servers.event +
        "/api/v2/" +
        this.$_getLocale() +
        "/game/event";

      this.eventsApi.callbackReset = () => {
        this.eventsApi.isLoading = true;
        this.eventsApi.isError = false;
      };

      this.eventsApi.callbackError = (e) => {
        this.eventsApi.isLoading = false;
        this.eventsApi.isError = true;
        this.eventsApi.error = e;
        this.apiError = this.eventsApi;
      };
      this.eventsApi.callbackSuccess = (resp) => {
        this.isOngoingEvent = resp.data.ongoing && resp.data.ongoing.length > 0;
      };
      await this.$api.fetch(this.eventsApi);
    },
    async loadCoins() {
      this.coinApi.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/inventory";
      this.coinApi.callbackReset = () => {
        this.coinApi.isLoading = true;
        this.coinApi.isError = false;
        this.coinApi.error = null;
      };
      this.coinApi.callbackError = (e) => {
        this.coinApi.isLoading = false;
        this.coinApi.isError = true;
        this.coinApi.error = e;
        this.apiError = this.coinApi;
      };
      this.coinApi.callbackSuccess = (resp) => {
        this.coinApi.isLoading = false;
        var coins = null;
        coins = resp.filter(function (entry) {
          return entry.Item.key == "goldcoin";
        });
        var goldenbrush = null;
        goldenbrush = resp.filter(function (entry) {
          return entry.Item.key == "goldenbrush";
        });
        if (goldenbrush[0]) {
          this.goldenbrush = goldenbrush[0].Inventory.quantity;
        } else {
          this.goldenbrush = 0;
        }
        if (coins[0]) {
          this.coins = coins[0].Inventory.quantity;
        } else {
          this.coins = 0;
        }
        this.$store.commit("updateCoin", {
          Goldenbrush: { quantity: this.goldenbrush },
          Currency: { quantity: this.coins },
        });
        this.isEnoughCoin = this.coins > 0;
      };
      await this.$api.fetch(this.coinApi);
    },

    startIntroJS(
      id,
      text,
      timeout = 1000,
      image = require("@/assets/tutorial/chat_1.png"),
      sfx = require("@/assets/sounds/sfx_chat_1.mp3")
    ) {
      this.$emit("update:intraction", "pointer-events: none;");
      setTimeout(() => {
        this.$intro().exit();
        this.$intro()
          .setOptions({
            exitOnOverlayClick: false,
            showButtons: false,
            showBullets: false,
            steps: [
              {
                element: document.querySelector(id),
                intro: '<img src="' + image + '">' + text,
              },
            ],
          })
          .start();
        this.$emit("update:intraction", "pointer-events: all;");
        let audio = new Audio(sfx);
        audio.volume = this.settings.audio.sfx * this.settings.audio.master;
        audio.play();
      }, timeout);
    },

    async callback() {
      this.chatStart = false;
      // #tutWroldIntro - after the intrduction finish, update tutorial
      if (this.tutorial.Ongoing == "tutWroldIntro") {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutWroldIntro";
        tempTut.Step = 2;
        this.$store.commit("updateTutorial", tempTut);

        this.startIntroJS(
          "#arrowLeft",
          this.$t("newTutorial.worldIntro.dialog_5")
        );
      }

      // #tutExploreEvents - after the event tutorial intrduction finish it will triger introjs to gide user to click hamochi cup
      else if (
        this.tutorial.Ongoing == "tutExploreEvents" &&
        this.tutorial.Step == 1
      ) {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreEvents";
        tempTut.Step = 2;
        this.$store.commit("updateTutorial", tempTut);

        this.startIntroJS(
          "#arrowLeft",
          this.$t("tutorial.exploreEvents.dialog_4")
        );
      } else if (
        this.tutorial.Ongoing == "tutExploreEvents" &&
        this.tutorial.Step == 3
      ) {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreEvents";
        tempTut.Step = 4;
        this.$store.commit("updateTutorial", tempTut);

        this.startIntroJS(
          "#entrance",
          this.$t("tutorial.exploreEvents.dialog_2")
        );
      }

      // #tutExploreShop - after the shop tutorial intrduction finish it will triger introjs to gide user to click menu button
      else if (
        this.tutorial.Ongoing == "tutExploreShop" &&
        this.tutorial.Step == 1
      ) {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreShop";
        tempTut.Step = 2;
        this.$store.commit("updateTutorial", tempTut);

        this.startIntroJS(
          "#buttonHome",
          this.$t("tutorial.exploreShop.dialog_2")
        );
      } else if (
        this.tutorial.Ongoing == "tutExploreTower" &&
        this.tutorial.Step == 1
      ) {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreTower";
        tempTut.Step = 1.5;
        this.$store.commit("updateTutorial", tempTut);

        this.startIntroJS(
          "#arrowRight",
          this.$t("tutorial.exploreTower.dialog_2")
        );
      } else if (
        this.tutorial.Ongoing == "tutExploreTower" &&
        this.tutorial.Step == 4
      ) {
        await this.completeTutorial("tutExploreTower");
        this.startIntroJS(
          "#GoTower",
          this.$t("tutorial.exploreTower.dialog_8")
        );
      } else if (
        this.tutorial.Ongoing == "tutExploreAbc" &&
        this.tutorial.Step == 1
      ) {
        let tempTut = this.$_.cloneDeep(this.tutorial);
        tempTut.Ongoing = "tutExploreAbc";
        tempTut.Step = 1.5;
        this.$store.commit("updateTutorial", tempTut);

        this.startIntroJS(
          "#arrowRight",
          this.$t("tutorial.exploreABC.dialog_3")
        );
      } else if (
        this.tutorial.Ongoing == "tutExploreAbc" &&
        this.tutorial.Step == 5
      ) {
        this.startIntroJS(
          "#EN_Y010_B010",
          this.$t("tutorial.exploreABC.dialog_11")
        );
      } else if (
        this.tutorial.Ongoing == "tutExploreAbc" &&
        this.tutorial.Step == 6
      ) {
        await this.completeTutorial("tutExploreAbc");
        this.startIntroJS(
          "#EN_Y010_B010_C010",
          this.$t("tutorial.exploreABC.dialog_17")
        );
      } else if (
        this.tutorial.Ongoing == "tutExploreFamily" &&
        this.tutorial.Step == 1
      ) {
        this.startIntroJS(
          "#FAMILY_BTN",
          this.$t("tutorial.exploreFamily.dialog_3")
        );
      } else if (
        this.tutorial.Ongoing == "tutExploreFamily" &&
        this.tutorial.Step == 2
      ) {
        await this.completeTutorial("tutExploreFamily");
      }
    },
  },
};
</script>
